import { useMemo } from "react";
import { UAParser } from "ua-parser-js";
import { isStandalonePWA } from "ua-parser-js/helpers";

export const useBrowserInfo = () =>
  useMemo(() => {
    const parser = new UAParser();
    const result = parser.getResult();
    return result;
  }, []);

export const useCanInstallPWA = () => {
  const browserInfo = useBrowserInfo();

  const canInstall = useMemo(() => {
    return !isStandalonePWA() && browserInfo.device.type === "mobile";
  }, [browserInfo.device.type]);

  return { canInstall };
};
